import { Component, inject, OnInit, signal } from '@angular/core';
import { LoaderComponent } from '@lib-ui/loader/loader.component';
import { MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { PersonService } from '@lib-services/person.service';
import { AuthService } from '@lib-ui/auth/auth.service';
import { IPerson } from '@lib-typing/person.interface';
import { MessageService } from '@lib-services/message.service';
import { Person } from '@libs-classes/person.class';
import { MatCardTitle } from '@angular/material/card';
import { OfflineService } from '@lib-ui/offline/offline.service';
import { getErrorMessage } from '../../../../../../libs/utils/getErrorMessage';

@Component({
    selector: 'app-form-cash-machine',
    standalone: true,
    imports: [
        LoaderComponent,
        MatDialogContent,
        MatButton,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
        MatCardTitle,
        MatError,
    ],
    templateUrl: './form-cash-machine.component.html',
    styleUrl: './form-cash-machine.component.scss'
})
export class FormCashMachineComponent {
    user = new Person({} as IPerson);
    loading = signal(false);
    private fb = inject(FormBuilder);
    readonly dialogRef = inject(MatDialogRef<FormCashMachineComponent>);
    private userService= inject(PersonService);
    private authService = inject(AuthService);
    private messageService = inject(MessageService);
    private offlineService = inject(OfflineService);
    protected readonly getErrorMessage = getErrorMessage;

    form = this.fb.group({
        paymentDeviceSn: ['', [Validators.required, Validators.minLength(15)]],
    });

    onSubmit(): void {
        if (this.offlineService.offline()) {
            this.messageService.errorMessage('Отсутствует подключение к интернету');
            return;
        }

        this.loading.set(true);

        const user = this.authService.user().dataForUpdatePaymentDeviceSn(this.form.controls.paymentDeviceSn.value || '');

        this.userService.update(user)
            .subscribe({
                next: (res) => {
                    this.authService.user().updateData(res);
                    this.dialogRef.close(res);
                    this.messageService.successMessage('ИН Кассы был успешно сохранен');
                },
                error: err => this.messageService.errorMessage(err.error.message),
            }).add(() => this.loading.set(false));
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
